// extracted by mini-css-extract-plugin
module.exports = {"btn":"blog-post-module--btn--2G6C6"};